import React, { useState, useEffect, useRef } from 'react'
// import { useLocation } from 'react-router-dom' 
import './toggle.scss'

const Toggle = ({ data, onChange, list, Class, defaultValue, label, style, info }) => {
    const [activeIndex, setActiveIndex] = useState(null)
    const [translateValue, setTranslateValue] = useState(0)
    const [width, setWidth] = useState(0)
    const toogleTab = useRef(), input = useRef()
    useEffect(() => {

        if (defaultValue) {
            let active_index = 0
            list.map((l, i) => {
                if (l.name === defaultValue.name) {
                    active_index = i
                }
            })
            setActiveIndex(active_index)
        }else{
            setActiveIndex(null)
        }
    }, [defaultValue])
    useEffect(() => {
        if (activeIndex !== null) {
            let select = toogleTab.current.children[activeIndex].children[1]
            // let selectAll = document.querySelectorAll(`${Class ? Class : ''} .tabs > div`)
            let selectAll = toogleTab.current.children
            if (select && select.clientWidth) {
                let button_width = select.clientWidth
                let translateX = 0
                setWidth(button_width)
                for (let i = 0; i < selectAll.length - 1; i++) {
                    if (activeIndex > i) {
                        translateX += selectAll[i].clientWidth
                    }
                }
                setTranslateValue(translateX)
            }
        } else {
            setWidth(0)
        }
    }, [activeIndex]);
    return (
        <div style={style} className='toggle'>
            {label && <label className='tabs_label'>{label}</label>}
            <div className="tabs" ref={toogleTab}>
                {
                    list && list.map((l, i) => (<div key={l.name}>
                        <input
                            ref={input}
                            type="radio"
                            className={`radio-${i + 1}`}
                            name="tabs"
                            checked={i === activeIndex ? true : false}
                        />
                        {
                            l.title ? (<>
                                <button

                                    className={"tab tab_note"} htmlFor={`radio-${i + 1}`}
                                    onClick={() => {
                                        setActiveIndex(i)
                                        onChange(l)
                                    }} >
                                    <p>{l.title}</p>
                                    <p>{l.note}</p>
                                </button>
                            </>) : (<button
                                style={i === activeIndex ? { color: 'white' } : {}}
                                className="tab"
                                onClick={() => {
                                    setActiveIndex(i)
                                    onChange(l)
                                }} >{l.name}</button>)
                        }
                    </div>))
                }
                <span className="glider" style={{ width: width, transform: `translateX(${translateValue}px)` }}></span>
            </div>
            {info && (<p className='text'>{info}</p>)}
        </div>
    )
}

export default Toggle